import React from "react";

import { faCircleCheck, faCircleExclamation } from "@fortawesome/pro-solid-svg-icons";

import { Icon } from "@performyard/py-components";
import { EmployeeSummary } from "@performyard/service-contracts";

import { BulletListSection } from "../components/BulletListSection";
import { StatCard, StatRow, StatRows } from "../components/StatCard";

export const GoalsSection: React.FC<{ summary: EmployeeSummary }> = ({ summary }) => {
	const goalsCount = summary.signal_counts.goals;
	const stats = summary.goals_stats;
	const insights = summary.goals_insights;

	return (
		<div className="mt-1 flex flex-col gap-2">
			<div className="flex gap-2" data-testid="goals-counts">
				{stats !== null ? (
					<>
						{/* Assigned == signal_counts.goals (same query), so it replaces the Total Goals tile. */}
						<StatCard label="Assigned" value={stats.assigned} testId="goals-stat-assigned" />
						<StatCard label="Goal Status" testId="goals-stat-status">
							<StatRows>
								<StatRow
									label="Completed"
									value={stats.completed}
									icon={<Icon icon={faCircleCheck} size={12} color="green-5" />}
									testId="goals-stat-completed"
								/>
								<StatRow
									label="Overdue"
									value={stats.overdue}
									icon={<Icon icon={faCircleExclamation} size={12} color="red-5" />}
									testId="goals-stat-overdue"
								/>
							</StatRows>
						</StatCard>
						<StatCard
							label="Average Progress"
							value={stats.avg_progress === null ? "—" : `${Math.round(stats.avg_progress)}%`}
							testId="goals-stat-avg-progress"
						/>
						<StatCard label="Created" value={stats.created} testId="goals-stat-created" />
					</>
				) : (
					<StatCard label="Total Goals" value={goalsCount} testId="goals-count-total" />
				)}
			</div>

			{insights !== null ? (
				<div className="flex flex-col gap-3" data-testid="goals-insights">
					<BulletListSection title="Goal Execution" items={insights.execution} testId="goals-execution" />
					<BulletListSection
						title="Patterns & Risks"
						items={insights.patterns_risks}
						testId="goals-patterns-risks"
					/>
				</div>
			) : null}
		</div>
	);
};
